import { OptionsType } from '../components/BaseSelect'
import { AllLanguagesOptions } from '../i18n/useTranslation'
import {} from '../context/types'

export const AUTO_ENTRY = { v: -1, k: 'auto' } as const

// TODO refactor this ...
export const PARAMS_MAP = {
    'langIndex': AllLanguagesOptions,
    'Deck size': [
        AUTO_ENTRY,
        //     // { v: 3, k: '3' },
        //     // { v: 5, k: '5' },
        //     // { v: 14, k: '14' },
        //     // { v: 28, k: '28' },
        //     { v: 9, k: '9 = 3 x 3' },
        //     { v: 12, k: '12 = 3 x 4' },
        //     { v: 15, k: '15 = 3 x 5' },
        //     { v: 21, k: '21 = 3 x 7' },
        //     { v: 30, k: '30 = 3 x 10' },
        //     { v: 42, k: '42 = 3 x 14' },
    ] as OptionsType<number>,
    'Nb of values': [
        { v: 14, k: '14 (full)' }, // MAX
        // { v: 10, k: '10' },
        // { v: 7, k: '7' },
        // { v: 5, k: '5' },
        // { v: 4, k: '4' },
        // { v: 3, k: '3' },
        // { v: 2, k: '2' },
    ] as OptionsType<number>,
    'Nb of rounds': [
        { v: 3, k: '3 (full)' }, // MAX
        // { v: 2, k: '2' },
        // { v: 1, k: '1' },
    ] as OptionsType<number>,
    Hourglass: [
        { v: 0, k: 'disabled' },
        // { v: 5, k: '5s' },
        // { v: 10, k: '10s' },
    ] as OptionsType<number>,
    'submit_confirmation': [
        { v: 0, k: 'disabled' },
        { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    Buckets: [
        // AUTO_ENTRY,
        // { v: 1, k: '1' },
        // { v: 2, k: '2' },
        // { v: 3, k: '3' },
        // { v: 4, k: '4' },
        // { v: 5, k: '5' },
        // { v: 6, k: '6' },
        // { v: 7, k: '7' },
        // { v: 8, k: '8' },
        { v: 9, k: '9' }, // MAX
        // { v: 14, k: '14' },
    ] as OptionsType<number>,
    'Stm / comparison': [
        AUTO_ENTRY,
        // { v: 1, k: '1' },
        // { v: 2, k: '2' }, // FIXME restore this?
        // { v: 3, k: '3' },
        // { v: 4, k: '4' },
        // { v: 5, k: '5' },
    ] as OptionsType<number>,
    'Bucket screen after': [
        AUTO_ENTRY,
        // { v: 1, k: '1' },
        // { v: 2, k: '2' },
        // { v: 3, k: '3' },
        // { v: 4, k: '4' },
        // { v: 5, k: '5' },
        // { v: 6, k: '6' },
        // { v: 7, k: '7' },
        // { v: 8, k: '8' },
        // { v: 9, k: '9' },
    ] as OptionsType<number>,
    // 'Skippable Stm': [
    //     { v: 0, k: 'disabled' },
    //     // { v: 1, k: 'enabled' },
    // ] as OptionsType<number>,
    // 'Save/Restore progress': [
    //     { v: 0, k: 'disabled' },
    //     { v: 1, k: 'enabled ' }, // FIXME restore this?
    // ] as OptionsType<number>,
    // 'Autoplay next': [
    //     // { v: 0, k: 'disabled' },
    //     { v: 1, k: 'enabled' },
    // ] as OptionsType<number>,
    'Remaining steps': [
        { v: 0, k: 'disabled' },
        // { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'go_back_comparison': [
        { v: 0, k: 'disabled' },
        // { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'Gamified UI': [
        { v: 0, k: 'disabled' },
        // { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'values_with_icons': [
        { v: 1, k: 'enabled' },
        { v: 0, k: 'disabled' },
    ] as OptionsType<number>,
    'Explanation of stm': [
        { v: 0, k: 'disabled' },
        // { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'Show bucket distrib': [
        { v: 0, k: 'disabled' },
        // { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'debug_mode': [
        { v: 0, k: 'disabled' },
        { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'download_report': [
        { v: 0, k: 'disabled' },
        // TODO clean this
        { v: 1, k: 'enabled' },
    ] as OptionsType<number>,
    'Overview after ranking [Stms.]': [
        // AUTO_ENTRY,
        { v: 0, k: 'Always' },
        // { v: 1, k: '1' },
        // { v: 2, k: '2' },
        // { v: 3, k: '3' },
        // { v: 4, k: '4' },
        // { v: 5, k: '5' },
        // // { v: 6, k: '6' },
        // { v: 7, k: '7' },
        // // { v: 8, k: '8' },
        // // { v: 9, k: '9' },
        // { v: 10, k: '10' },
        // // { v: 11, k: '11' },
        // // { v: 12, k: '12' },
        // // { v: 13, k: '13' },
        // { v: 14, k: '14' },
    ] as OptionsType<number>,
    // Colors of less important & more important
    // Absolute/relative scaleimport { updateRemainingSteps } from './parameters';
} as const
// TODO string
export type PARAMS = Record<keyof typeof PARAMS_MAP, number>

const defaults = {} as PARAMS
Object.entries(PARAMS_MAP).forEach(([k, options]) => {
    const firstOption = options[0]
    const firstValue = firstOption.v
    defaults[k as keyof PARAMS] = firstValue
})

export const DEFAULT_PARAMS: PARAMS = {
    ...defaults,
    // 'Stm / comparison': 2,
    // Hourglass: 0,
    // 'Deck size': 42,
    // 'Skippable Stm': 0,
    // 'Autoplay next': 1,
    // 'Remaining steps': 0,
    // 'go_back_comparison': 0,
    // 'Explanation of stm': 0,
    // 'Show bucket distrib': 0,
    // 'Gamified UI': 0,
}

